export default __webpack_public_path__ + "static/media/blog6_image.abae5aa7.png";